import { createContext } from 'react';

export type RenderContext =
  | 'form'
  | 'list'
  | 'taskList'
  | 'detail'
  | 'agenda'
  | 'calendar'
  | 'table';

export const CardRenderContext = createContext<RenderContext>('list');

export type LayoutContext = 'row' | 'column';

export const CardLayoutContext = createContext<LayoutContext>('column');
